"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyAutomaticOrderTemplate = exports.deleteAutomaticOrderTemplate = exports.fetchOrderList = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const validation_1 = require("../../types/validation");
const ActionTypes = require("../../actionTypes/order/list");
const Actions = require("../../actions/order/list");
const errorHandling_1 = require("../../utils/errorHandling");
const sok_types_1 = require("@caddigital/sok-types");
function fetchOrderList(action$, _store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/order/folder/${request.payload.folder.id}?filter=${request.payload.filter}&type=${request.payload.type}`
    }).pipe((0, operators_1.mergeMap)((res) => {
        const validation = t.array(sok_types_1.Order.iOrder).decode(res.response);
        const act = validation.fold(() => Actions.fetchOrderListFailed((0, validation_1.reporter)(validation)), (e) => Actions.fetchOrderListSuccess(e, request.payload.filter));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.fetchOrderListFailed(e))))));
}
exports.fetchOrderList = fetchOrderList;
function deleteAutomaticOrderTemplate(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_ORDER), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        body: { ids: request.payload.id },
        method: 'DELETE',
        url: `${baseUrl}api/order/`
    }).pipe((0, operators_1.mergeMap)((res) => t
        .array(sok_types_1.Order.iOrder)
        .decode(res.response)
        .fold((e) => (0, rxjs_1.of)(Actions.deleteOrderFailure((0, errorHandling_1.parseValidationError)(e))), (e) => (0, rxjs_1.of)(Actions.deleteOrderSuccess(e)))), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.deleteOrderFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.deleteAutomaticOrderTemplate = deleteAutomaticOrderTemplate;
function copyAutomaticOrderTemplate(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.COPY_ORDER), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/order/${request.payload.order.id}/copy`
    }).pipe((0, operators_1.mergeMap)((res) => {
        if (res.status < 400) {
            return (0, rxjs_1.merge)([
                Actions.copyOrderSuccess(),
                Actions.fetchOrderListRequest({ id: request.payload.order.folderId }, // ffs boyz
                store.value.order.list.filter, 'template')
            ]);
        }
        else {
            return (0, rxjs_1.of)(Actions.copyOrderFailure((0, errorHandling_1.parseAjaxErrorResponse)(res.response)));
        }
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.copyOrderFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.copyAutomaticOrderTemplate = copyAutomaticOrderTemplate;
//# sourceMappingURL=list.js.map